<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
      <div class="p-3">Multi-Factor Authentication (MFA)</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        @if (!isLoading) {
          <div>
            <div class="status-section">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <span class="status-indicator" [ngClass]="isMfaEnabled ? 'status-enabled' : 'status-disabled'">
                    {{ isMfaEnabled ? 'Enabled' : 'Disabled' }}
                  </span>
                </div>
                <div>
                  @if (!isMfaEnabled) {
                    <button class="mfa-btn mfa-btn-primary me-2" (click)="initiateMfaSetup()">
                      <i class="bi bi-shield-lock-fill me-2"></i>Enable MFA
                    </button>
                  }
                  @if (isMfaEnabled) {
                    <button class="mfa-btn mfa-btn-danger" (click)="disableMfa()">
                      <i class="bi bi-shield-slash-fill me-2"></i>Disable MFA
                    </button>
                  }
                </div>
              </div>
            </div>
            <!-- MFA Setup Section -->
            @if (setupDetails) {
              <div class="mfa-setup-section">
                <hr>
                  <h5 class="mb-4">Set Up Two-Factor Authentication</h5>
                  <div class="row">
                    <div class="col-lg-5 mb-4 mb-lg-0">
                      <div class="mfa-qr-container">
                        <p class="mb-3">Scan this QR code with your authenticator app</p>
                        <img [src]="setupDetails.qrCode" alt="MFA QR Code" class="mfa-qr-code img-fluid">
                        <div class="mfa-secret-container mt-4">
                          <p class="mfa-secret-label mb-2">Can't scan the QR code?</p>
                          <p class="mb-1">Enter this key manually:</p>
                          <code class="mfa-secret-key">{{ setupDetails.secret }}</code>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-7">
                      <div class="mfa-instructions mb-4">
                        <h6 class="mb-2">How to set up:</h6>
                        <ol class="mb-0">
                          <li>Install an authenticator app (Google Authenticator, Authy, etc.)</li>
                          <li>Scan the QR code or enter the key manually</li>
                          <li>Enter the 6-digit code generated by your app</li>
                          <li>Click "Verify & Enable" to complete setup</li>
                        </ol>
                      </div>
                      <div class="mfa-form-group">
                        <label for="otp" class="mfa-form-label">Verification Code</label>
                        <input
                          type="text"
                          id="otp"
                          class="mfa-form-control"
                          [(ngModel)]="otp"
                          (input)="onOtpInput($event)"
                          placeholder="123456"
                          maxlength="6"
                          autocomplete="off"
                          autofocus>
                        <div class="form-text text-muted">
                          Enter the 6-digit code from your authenticator app
                        </div>
                      </div>
                      @if (errorMessage) {
                        <div class="mfa-alert mfa-alert-danger">
                          {{ errorMessage }}
                        </div>
                      }
                      <div class="mt-4">
                        <button class="mfa-btn mfa-btn-success" (click)="verifyAndEnableMfa()" [disabled]="!otp || otp.length < 6">
                          <i class="bi bi-check-circle-fill me-2"></i>Verify & Enable
                        </button>
                        <button class="mfa-btn mfa-btn-secondary" (click)="cancelMfaSetup()">
                          <i class="bi bi-x-circle-fill me-2"></i>Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          @if (isLoading) {
            <div class="mfa-loading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-3 mb-0">Loading MFA status...</p>
            </div>
          }

          <div class="mfa-info-section mt-5">
            <h5 class="mfa-info-title">About Two-Factor Authentication</h5>
            <div class="mfa-info-content">
              <p>Two-factor authentication (2FA) adds an extra layer of security to your account. Once enabled, you'll be required to provide both your password and a code from your authenticator app when logging in.</p>
              <p>To use 2FA, download an authenticator app like Google Authenticator or Authy on your mobile device.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>